import { render, staticRenderFns } from "./BbsComment.vue?vue&type=template&id=392990b4&"
import script from "./BbsComment.vue?vue&type=script&lang=js&"
export * from "./BbsComment.vue?vue&type=script&lang=js&"
import style0 from "./BbsComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports